// Google Drive integration using Google Picker API
// See: https://developers.google.com/workspace/drive/picker/guides/overview

const CLIENT_ID = '916730590504-63sr99tj6dhpdt8j9vkvechml3j66b4n.apps.googleusercontent.com';
const API_KEY = 'AIzaSyBHimwpJFaS4xn23i6zwbPeBhU25napWvQ';
const SCOPES = 'https://www.googleapis.com/auth/drive.file https://www.googleapis.com/auth/drive.install https://www.googleapis.com/auth/userinfo.email';

let tokenClient;
let pickerCallback = null;

// Initialize the Google Identity Services
export function gisLoaded(setAccessToken) {
  tokenClient = google.accounts.oauth2.initTokenClient({
    client_id: CLIENT_ID,
    scope: SCOPES,
    callback: (response) => {
      if (response.error !== undefined) {
        throw response;
      }
      if (setAccessToken) setAccessToken(response.access_token);
      if (pickerCallback) {
        pickerCallback();
        pickerCallback = null;
      }
    },
  });
}

export async function signIn(setAccessToken) {
  return new Promise((resolve, reject) => {
    try {
      tokenClient.callback = (response) => {
        if (response.error !== undefined) {
          reject(response);
          return;
        }
        if (setAccessToken) setAccessToken(response.access_token);
        resolve(true);
      };
      tokenClient.requestAccessToken({ prompt: 'consent' });
    } catch (error) {
      console.error('Error signing in:', error);
      reject(error);
    }
  });
}

export function isSignedIn(accessToken) {
  return !!accessToken;
}

export function getCurrentUser(accessToken) {
  return isSignedIn(accessToken) ? { isAuthenticated: true } : null;
}

export async function readSvgFile(file, token) {
  console.log('Current access token:', token);
  try {
    // Step 1: Fetch file metadata
    const metaRes = await fetch(
      `https://www.googleapis.com/drive/v3/files/${file.id}?fields=id,mimeType,shortcutDetails&supportsAllDrives=true`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    if (!metaRes.ok) throw new Error('Failed to fetch file metadata');
    const meta = await metaRes.json();

    // Step 2: If shortcut, follow to target ID
    let realFileId = file.id;
    if (meta.mimeType === 'application/vnd.google-apps.shortcut' && meta.shortcutDetails) {
      realFileId = meta.shortcutDetails.targetId;
    }

    // Step 3: Download the file
    const response = await fetch(
      `https://www.googleapis.com/drive/v3/files/${realFileId}?alt=media&supportsAllDrives=true`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      }
    );
    if (!response.ok) {
      throw new Error('Failed to read file');
    }
    return await response.text();
  } catch (error) {
    console.error('Error reading file:', error);
    throw error;
  }
}

export async function saveSvgFile(content, fileNameOrId, isOverwrite = false, folderId = null, token) {
  try {
    const file = new Blob([content], { type: 'image/svg+xml' });
    const metadata = {
      name: isOverwrite ? undefined : fileNameOrId,
      mimeType: 'image/svg+xml',
      ...(folderId && !isOverwrite ? { parents: [folderId] } : {})
    };

    const form = new FormData();
    form.append('metadata', new Blob([JSON.stringify(metadata)], { type: 'application/json' }));
    form.append('file', file);

    const url = isOverwrite
      ? `https://www.googleapis.com/upload/drive/v3/files/${fileNameOrId}?uploadType=multipart`
      : 'https://www.googleapis.com/upload/drive/v3/files?uploadType=multipart';

    const method = isOverwrite ? 'PATCH' : 'POST';

    const response = await fetch(url, {
      method,
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: form
    });

    if (!response.ok) {
      throw new Error('Failed to save file');
    }

    return await response.json();
  } catch (error) {
    console.error('Error saving file:', error);
    throw error;
  }
}

export function signOut(setAccessToken) {
  if (setAccessToken) setAccessToken(null);
  if (window.google && window.google.accounts && window.google.accounts.id) {
    try {
      window.google.accounts.id.disableAutoSelect();
    } catch (e) {
      // ignore if not available
    }
  }
}

export async function getUserEmail(accessToken) {
  try {
    // If no access token, request one first
    if (!accessToken) {
      return new Promise((resolve, reject) => {
        tokenClient.callback = async (response) => {
          if (response.error !== undefined) {
            reject(new Error('Failed to get access token'));
            return;
          }
          try {
            const email = await fetchUserInfo(response.access_token);
            resolve(email);
          } catch (error) {
            reject(error);
          }
        };
        tokenClient.requestAccessToken({ prompt: 'consent' });
      });
    }

    // If we have a token, try to use it
    try {
      return await fetchUserInfo(accessToken);
    } catch (error) {
      // If token is invalid, request a new one
      return new Promise((resolve, reject) => {
        tokenClient.callback = async (response) => {
          if (response.error !== undefined) {
            reject(new Error('Failed to get new access token'));
            return;
          }
          try {
            const email = await fetchUserInfo(response.access_token);
            resolve(email);
          } catch (error) {
            reject(error);
          }
        };
        tokenClient.requestAccessToken({ prompt: 'consent' });
      });
    }
  } catch (error) {
    console.error('Error fetching user email:', error);
    throw error;
  }
}

async function fetchUserInfo(token) {
  const response = await fetch('https://www.googleapis.com/oauth2/v3/userinfo', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!response.ok) {
    throw new Error('Failed to fetch user info');
  }
  const data = await response.json();
  console.log('User email:', data.email); // For testing purposes
  return data.email;
} 